import {nsRoute} from "../../util/route";
import {withStaticAssetCacheBust} from "../../util/assetCacheBust";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import applicationHtml from './application.html?raw';

export let template = applicationHtml;

export class viewModel extends ParsedRouteDataDecorator {
    /** Cache-busted changelog HTML URL (`?ver=&t=`), same helpers as static CSS/JS. */
    readonly changelogHref = withStaticAssetCacheBust('changelog/client.html');
    readonly copyrightYear = new Date().getFullYear();
}
